<template lang="pug">
.branch-list
  //- サイドメニュー部
  side-menu.branch-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .branch-list__content
    breadcrumb-list.branch-list__content__breadcrumb(:breadcrumbs='breadcrumbs', :buttonEvent='openRegisterModal')
      template(#buttonLabel)
        slot(name='breadcrumbButtonLabel')
    .branch-list__content__body
      .branch-list__content__body__heading
        tab-heading.branch-list__content__body__heading__tab(
          :isActive='false',
          @click='tabHeadingEvent(tabSetting.ACADEMY.value)'
        ) {{ tabSetting.ACADEMY.text }}
        tab-heading.branch-list__content__body__heading__tab(:isActive='true') {{ tabSetting.BRANCH.text }}
      .branch-list__content__body__main
        .branch-list__content__body__main__action
          search-branch.branch-list__content__body__main__action__search(
            :academyName='academyName',
            :branchName='branchName',
            :branchCode='branchCode',
            :academyNamePlaceholder='academyNamePlaceholder',
            :branchNamePlaceholder='branchNamePlaceholder',
            :branchCodePlaceholder='branchCodePlaceholder',
            :academyNameChangeEvent='setAcademyName',
            :branchNameChangeEvent='setBranchName',
            :branchCodeChangeEvent='setBranchCode',
            :searchEvent='searchEvent'
          )
            template(#searchButtonText)
              slot(name='searchButtonText')
          .branch-list__content__body__main__action__button
            button-icon-circle.branch-list__content__body__main__action__button__icon(
              type='download',
              @click='downloadEvent'
            )
              slot(name='downloadIconLabel')
            button-upload.branch-list__content__body__main__action__button__icon(:uploadEvent='uploadEvent')
              template(#iconLabel)
                slot(name='uploadIconLabel')
        branch-list-table.branch-list__content__body__main__table(
          v-if='sort && branchDatas',
          :checkedAll='checkedAll',
          :headerCheckboxChangeEvent='setCheckedAll',
          :sort='sort',
          :sortChangeEvent='changeSort',
          :branchDatas='branchDatas',
          :checkedBranchIds='checkedBranchIds',
          :checkboxChangeEvent='setCheckedBranchIds',
          :deleteEvent='deleteEvent',
          :editEvent='openEditModal'
        )
          template(#academyNameHeader)
            slot(name='academyNameHeader')
          template(#branchNameHeader)
            slot(name='branchNameHeader')
          template(#branchCodeHeader)
            slot(name='branchCodeHeader')
          template(#updatedDateHeader)
            slot(name='updatedDateHeader')
          template(#editHeader)
            slot(name='editHeader')
          template(#popupRemoveText)
            slot(name='popupRemoveText')
          template(#popupEditText)
            slot(name='popupEditText')
        .branch-list__content__body__main__footer
          button-pagination.branch-list__content__body__main__footer__pager(
            :status='pagenationStatus',
            @click='pagenationEvent'
          )
  //- モーダル部
  modal-branch-edit.branch-list__modal(
    v-if='branchEditData',
    ref='modalBranchEdit',
    :title='modalTitle',
    :branchNamePlaceholder='modalBranchNamePlaceholder',
    :branchCodePlaceholder='modalBranchCodePlaceholder',
    :branchEditData='branchEditData',
    :academySelectOptions='academySelectOptions',
    :keepButtonEvent='modalKeepButtonEvent',
    :errorMessages='modalErrorMessages'
  )
    template(#academyNameLabel)
      slot(name='modalAcademyNameLabel')
    template(#academyNameDisabledLabel)
      slot(name='modalAcademyNameDisabledLabel')
    template(#branchNameLabel)
      slot(name='modalBranchNameLabel')
    template(#branchCodeLabel)
      slot(name='modalBranchCodeLabel')
    template(#branchCodeDisabledLabel)
      slot(name='modalBranchCodeDisabledLabel')
    template(#keepText)
      slot(name='modalKeepText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import SearchBranch from '@/components/organisms/manager/SearchBranch.vue'
import ButtonIconCircle from '@/components/molecules/manager/ButtonIconCircle.vue'
import ButtonUpload from '@/components/molecules/manager/ButtonUpload.vue'
import BranchListTable from '@/components/organisms/manager/BranchListTable.vue'
import ButtonPagination from '@/components/molecules/manager/ButtonPagination.vue'
import ModalBranchEdit from '@/components/organisms/manager/ModalBranchEdit.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { BranchListType, BranchListSortType, BranchEditType } from '@/models/branchListModel'
import { InputItem } from '@/models/inputItem'
import { PaginationStatus } from '@/models/paginationModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'
import { AcademyBranchTabSetting } from '@/const/TabLinkSettings'
import { SortSetting } from '@/const/SortSettings'

/**
 * 教室管理画面
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    SearchBranch,
    ButtonIconCircle,
    ButtonUpload,
    BranchListTable,
    ButtonPagination,
    ModalBranchEdit,
  },
})
export default class BranchList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // 新規登録用の情報設定イベント
  @Prop()
  setRegisterDataEvent!: Function

  // 見出しタブクリック時のイベント
  @Prop()
  tabHeadingEvent!: Function

  // 塾名プレースホルダー
  @Prop()
  academyNamePlaceholder!: string

  // 教室名プレースホルダー
  @Prop()
  branchNamePlaceholder!: string

  // 教室コードプレースホルダー
  @Prop()
  branchCodePlaceholder!: string

  // 検索ボタン押下時イベント
  @Prop()
  searchEvent!: Function

  // ダウンロードボタン押下時イベント
  @Prop()
  downloadEvent!: Function

  // アップロードボタン押下時イベント
  @Prop()
  uploadEvent!: Function

  // ソート情報
  @Prop()
  sort!: BranchListSortType

  // 教室一覧情報
  @Prop()
  branchDatas!: BranchListType[]

  // 削除ボタン押下時イベント
  @Prop()
  deleteEvent!: Function

  // 編集用の情報設定イベント
  @Prop()
  setEditDataEvent!: Function

  // ページネーションの状態
  @Prop()
  pagenationStatus!: PaginationStatus

  // ページネーションイベント
  @Prop()
  pagenationEvent!: Function

  // モーダルのタイトル
  @Prop()
  modalTitle!: string

  // 編集対象の教室情報
  @Prop()
  branchEditData!: BranchEditType

  // 塾名選択プルダウンのオプション
  @Prop()
  academySelectOptions!: InputItem[]

  // モーダルの教室名プレースホルダー
  @Prop()
  modalBranchNamePlaceholder!: string

  // モーダル教室コードプレースホルダー
  @Prop()
  modalBranchCodePlaceholder!: string

  // モーダルの保存ボタン押下時イベント
  @Prop()
  modalKeepButtonEvent!: Function

  // モーダルに表示するエラーメッセージ
  @Prop()
  modalErrorMessages!: string[]

  // モーダルref
  @Ref()
  modalBranchEdit!: ModalBranchEdit

  // === 選択値を保持する変数群
  // 塾名
  public academyName = ''
  // 教室名
  public branchName = ''
  // 教室コード
  public branchCode = ''
  // 全チェックフラグ
  public checkedAll = false
  // チェックされた教室ID
  public checkedBranchIds: number[] = []

  // === 選択値をセットする関数群
  // 塾名をセット
  private setAcademyName(value: string) {
    this.academyName = value
  }
  // 教室名をセット
  private setBranchName(value: string) {
    this.branchName = value
  }
  // 教室コードをセット
  private setBranchCode(value: string) {
    this.branchCode = value
  }
  // 全チェックフラグをセット
  private setCheckedAll(value: boolean) {
    this.checkedAll = value
  }
  // チェックされた教室IDをセット
  private setCheckedBranchIds(value: number[]) {
    this.checkedBranchIds = value
  }

  // ソート値を変更
  private changeSort(sortSetting: SortSetting, sortTarget: string) {
    const sort = this.sort
    sort[sortTarget] = sortSetting
    this.$emit('sort-changed', sort)
  }

  // 新規登録モーダルを開く
  private async openRegisterModal() {
    await this.setRegisterDataEvent()
    if (this.branchEditData) {
      this.modalBranchEdit.show()
    }
  }

  // 編集モーダルを開く
  private async openEditModal(id: number) {
    await this.setEditDataEvent(id)
    if (this.branchEditData) {
      this.modalBranchEdit.show()
    }
  }

  // 見出しタブリンクの表示設定
  private get tabSetting(): AcademyBranchTabSetting {
    return AcademyBranchTabSetting
  }
}
</script>

<style lang="stylus" scoped>
.branch-list
  display flex
  width 100%
  height 100%

  &__content
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 20px
    overflow-y auto

    &__body
      display flex
      flex-direction column

      &__heading
        display flex
        height 43px

        &__tab
          &:nth-child(1)
            border-bottom-left-radius 12px

      &__main
        z-index 1
        width 100%
        min-height 500px
        display flex
        flex-direction column
        border-radius 15px
        background var(--color-manager-list__background)
        box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)

        &__action
          display flex
          justify-content space-between
          align-items center
          padding 12px 20px

          &__search
            padding 7px 5px

          &__button
            display flex
            gap 12px

            &__icon
              width 32px
              height 32px

        &__footer
          display flex
          justify-content flex-end
          align-items center
          padding 20px 30px
          margin-top auto
</style>
